<form class="m-t-20" [formGroup]="form" (submit)="handlerSubmit()">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <div class="container-icon">
            <input
              class="form-control"
              type="text"
              name="search"
              maxlength="40"
              placeholder="{{ 'quotes.basicSearch.searchbox.placeholder' | cxTranslate }}"
              formControlName="search"
            />

            <button class="icon">
              <span class="material-symbols-outlined"> search </span>
            </button>
          </div>

          <cx-form-errors [control]="form.get('search')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
</form>
